import { gql } from "@outschool/ui-apollo";

const TutoringCategoriesQuery = gql`
  query TutoringRelatedCategoriesQuery {
    categoryPage(slug: "tutoring") {
      related {
        nameTitleCased
        slug
        basePath
      }
      children {
        nameTitleCased
        slug
        basePath
      }
    }
  }
`;

export default TutoringCategoriesQuery;
